// get container based on data attribute
const faqsItems = document.querySelector('.faqs-block__faqs-items');
function setupFaqsToggle() {
    const faqsItems = document.querySelectorAll('.faqs-block__item');

    faqsItems.forEach(item => {
        item.addEventListener('click', () => {
            // Get the faqsRow from the clicked item
            const faqsRow = item.dataset.faqsRow;
            if (faqsRow) {
                // Find the corresponding row element
                const rowElement = document.querySelector(`[data-faqs-row="${faqsRow}"]`);
                if (rowElement) {
                    // Check if the clicked item is already active
                    if (rowElement.classList.contains('faqs--active')) {
                        // If it is active, remove the active class to hide it
                        rowElement.classList.remove('faqs--active');
                    } else {
                        // If it is not active, remove active class from all rows
                        const allRows = document.querySelectorAll('.faqs-block__item');
                        allRows.forEach(row => {
                            row.classList.remove('faqs--active');
                        });
                        // Add the active class to the clicked row
                        rowElement.classList.add('faqs--active');
                    }
                }
            }
        });
    });
}

setupFaqsToggle();